const UTILS = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
  FormatMoney(cents) {
    let MoneyFormatter = new Intl.NumberFormat(this.language, {
      style: "currency",
      currency: "USD",
    });
    return MoneyFormatter.format(cents / 100);
  },
  async AddItemsToCart (items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  async UpdateCartItems(updates) {
    return await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    }).then(res => res.json());
  },
  async UpdateCartItem(item) {
    if (!item) return;
  
    return await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });
  },
  async GetCart() {
    return await fetch('/cart.js').then(res => res.json());
  },
  GetVariantSellingPlan(product, variant, plan_id) {
    if (!product || !variant || !plan_id) return;

    let plan = product.all_selling_plans.find(item => item.id == plan_id);
    if (!plan) return;

    let price_adjustment_type = plan.price_adjustments[0].value_type;
    let plan_price;
    if (price_adjustment_type == 'percentage') {
      plan_price = (variant.price * (100 - plan.price_adjustments[0].value)) / 100;
    }
    else {
      plan_price = plan.price_adjustments[0].value;
    }
    plan.price = plan_price;

    let plan_display_name = plan.name;
    switch(plan.name) {
      case 'Every 1 month':
        plan_display_name = 'Monthly Plan';
        break;
      case 'Every 3 months':
        plan_display_name = '3 Month Plan';
        break;
    }
    plan.display_name = plan_display_name;

    let is_quarter = false;
    if (plan.name.indexOf('1 month') !== -1) {
      plan.prefix = 'paid monthly';
    }
    if (plan.name.indexOf('3 month') !== -1) {
      is_quarter = true;
      plan.prefix = 'paid quarterly';
    }

    plan.price_per_month = is_quarter ? (plan.price / 3) : plan.price;

    // saving calculation
    let price_to_compare = variant.price;
    if (variant.compare_at_price) {
      price_to_compare = variant.compare_at_price;
    }
    let savings = ((price_to_compare - plan_price) / variant.price) * 100;
    plan.savings = `${ savings.toFixed(0) }%`;

    plan.identifier = `${ variant.title }--${ plan.name }`.toLowerCase().replaceAll(' ', '-');
    // console.log(product.all_selling_plans, plan_id, plan)
    return plan; 
  },
  ObserveCartRequests() {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.name.indexOf('/cart/') !== -1) {
          // console.log(entry)
          document.dispatchEvent(new CustomEvent('cart:modified', {detail: {entry}}));
        }
      }
    });
    
    observer.observe({
      entryTypes: ["resource"]
    });    
  },
  ObserveMutation(selector, options, callback) {
    let observer = new MutationObserver(callback);

    // Notify me of everything!
    let observerConfig = {
      attributes: true, 
      childList: true, 
      characterData: true 
    };
    observerConfig = Object.assign(observerConfig, options);

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });  
  },
  async FormSubmitAjax(form) {
    return await fetch(form.action, { method: 'POST', body: new FormData(form) });
  },
  Convert2JSON(json) {
    return JSON.parse(JSON.stringify(json));
  }
};

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductForm_v1', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      let section_id = 'product-form-v1';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        // console.log(product_res)
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            // console.log(e);
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

  Alpine.data('CustomProductForm_V1', (product) => ({
    product: product,
    cache: {},
    quantity: 1,
    purchaseType: 'subscribe',
    current_selling_plan: null,
    current_variant: null,
    init() {
      let am = this;
      am.InitSelf();
      am.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.cache.$formWrap = am.$el.closest('.product-form-wrap');
      am.flags.variant_picker = am.cache.$formWrap.dataset.variant_picker == 'true';

      am.current_variant = am.GetCurrentVariant();
      am.current_selling_plan = am.GetSubscriptionPlan();
    },
    InitWatchers() {
      let am = this;
      am.$watch('quantity', () => {
        let current_variant = am.GetCurrentVariant();
        am.current_variant = current_variant;
        am.product.current_variant = current_variant;
        am.current_selling_plan = am.GetSubscriptionPlan();
      });
    },
    FormatMoney(cents) {
      return UTILS.FormatMoney(cents);
    },
    GetCurrentVariant() {
      let am = this;
      let variant = am.product.variants.find(v => v.title.includes(`${am.quantity} Pack`));
      return variant;
    },
    GetSubscriptionPlan() {
      let am = this;
      let variant = am.GetCurrentVariant();
      let selling_plans = am.product.selling_plan_groups[0].selling_plans.filter(item => item.name.includes(am.quantity)) || am.product.selling_plan_groups[0].selling_plans[0];
      let selling_plan = variant.selling_plan_allocations.find(item => selling_plans.map(p => p.id).includes(item.selling_plan_id)) || variant.selling_plan_allocations[0];
      return selling_plan;
    },
    async e_AddToCart(e) {
      e.preventDefault();
      let $product_form = e.target.closest('.custom-product-atc-form');
      await UTILS.FormSubmitAjax($product_form);

      document.dispatchEvent(new Event('cart:modified'));
    },
    GetSavings(variant, pack) {
      let am = this;
      let savings = variant.compare_at_price - variant.price;
      if (am.purchaseType == 'subscribe') {
        savings = (variant.compare_at_price - (variant.selling_plan_allocations[0].per_delivery_price));
      }
      return {
        savings: savings,
        savings_money: `Save ${am.FormatMoney(savings)}`
      };
    }
  }));

  Alpine.data('ProductForm_v2', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      let section_id = 'product-form-v2';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        // console.log(product_res)
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            // console.log(e);
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

  Alpine.data('CustomProductForm_V2', (product) => ({
    product: product,
    cache: {},
    flags: {
      variant_picker: false,
      add_upsell: false
    },
    computed: {
      selling_plans: [],
      current_variant_plans: []  
    },
    selected: {
      purchaseOption: '',
      selling_plan: null
    },
    selected_upsell: {
      product: null,
      variant: null,
      purchaseOption: '',
      selling_plan: null
    },
    init() {
      let am = this;
      am.InitSelf();
      am.InitWatchers();
      am.SetComputed();
      setTimeout(am.ToggleUpsells.bind(am), 0);

      if (am.flags.preselect_quarterly) {
        am.$nextTick(() => {
          let $quarterly = am.$el.querySelector('.main-product-wrap [data-identifier="3-pack--every-3-months"]');
          $quarterly.dispatchEvent(new Event('click', {bubbles: true}));
        }, 0);
      }  

      // If variant changed
      am.$el.closest('.product-form-wrap').addEventListener('variant-change', (e) => {
        // /console.log(e);
        let $target = e.detail.e.target;
        let option_name = $target.getAttribute('name');
        let option_value = $target.value;
        let option = am.product.options_with_values.find(o => o.name == option_name);
        let option_id = `option${ option.position }`;
        let variant = am.product.variants.find(v => v[option_id] == option_value);
        am.product.current_variant = variant;
        am.$nextTick(am.SetComputed.bind(am));
        // debugger;
      });
    },
    InitSelf() {
      let am = this;
      am.cache.$formWrap = am.$el.closest('.product-form-wrap');
      am.flags.variant_picker = am.cache.$formWrap.dataset.variant_picker == 'true';

      let quarterlyDefault = am.cache.$formWrap.dataset.quarterlyDefault;
      am.flags.preselect_quarterly = quarterlyDefault ? JSON.parse(quarterlyDefault) : false;
    },
    InitWatchers() {
      let am = this;
      // watch selling plan
      am.$watch('selected.purchaseOption', () => {
        am.$nextTick(() => {
          if (am.flags.variant_picker) {
            am.selected.selling_plan = am.computed.current_variant_plans.find(item => item.id == am.selected.purchaseOption);
          }
          else {
            let $selected = am.cache.$formWrap.querySelector('[name="purchaseOption"]:checked');
            let variant_id = $selected.dataset.variant;
            let variant = am.product.variants.find(v => v.id == variant_id);
            am.cache.$formWrap.querySelector('[name=id]').value = variant_id;
            let selling_plan_id = $selected.value;
            am.selected.selling_plan = am.GetPlan(am.product, variant, selling_plan_id);            
          }

          setTimeout(am.ToggleUpsells.bind(am), 0);
        });
      });

      // after upcart add to cart, add upsells
      document.addEventListener('form:added-to-cart', (e) => {
        if (!am.flags.add_upsell) return;

        // Add Upsell item
        (async() => {
          let selling_plan = am.selected.purchaseOption !== 'one-time' ? am.selected_upsell.variant.selling_plan_allocations[0].selling_plan_id : null;
          let items_to_add = [{
            quantity: 1,
            id: am.selected_upsell.variant.id,
            selling_plan: selling_plan,
            properties: {}
          }];
          console.warn('Adding upsell item to cart', items_to_add);
          await UTILS.AddItemsToCart(items_to_add);
          document.dispatchEvent(new CustomEvent('cart:modified'));
        })();
      });
    },
    SetComputed() {
      let am = this;
      am.computed.selling_plans = am.product.selling_plan_groups.flatMap(g => g.selling_plans);

      let current_variant_plans = am.computed.selling_plans.filter((item) => {
        return am.product.current_variant.selling_plan_allocations.map(a => a.selling_plan_id).join('|').indexOf(item.id) !== -1;
      });
      // filter out plans that are not 1 or 3 months
      current_variant_plans = current_variant_plans.filter(plan => plan.name.indexOf('1 month') !== -1 || plan.name.indexOf('3 month') !== -1);

      am.computed.current_variant_plans = current_variant_plans;
      am.computed.current_variant_plans.forEach((plan) => {
        plan = am.GetPlan(am.product.current_variant, plan.id);
      });

      let plan_monthly = am.computed.current_variant_plans.find(plan => plan.name.indexOf('1 month') !== -1);
      am.selected.purchaseOption = plan_monthly ? plan_monthly.id : 'one-time';
    },
    GetPlan(product, variant, plan_id) {
      return UTILS.GetVariantSellingPlan(product, variant, plan_id); 
    },
    FormatMoney(cents) {
      return UTILS.FormatMoney(cents);
    },
    ToggleUpsells() {
      let am = this;
      let $upsells = am.$el.querySelector('.upsells-wrap');
      if (!$upsells) return;

      let $selected = am.cache.$formWrap.querySelector('[name="purchaseOption"]:checked');
      let $identifier = $selected.closest('[data-identifier]');
      if (!$identifier) return;
      let id = $identifier.dataset.identifier;
      $upsells.querySelectorAll('[data-identifier]').forEach(($item) => {
        $item.classList.add('hidden');
      });

      let $matching_upsell = $upsells.querySelector(`[data-identifier="${id}"]`);
      if ($matching_upsell) {
        $matching_upsell.classList.remove('hidden');
        $upsells.classList.remove('hidden');

        if (am.flags.add_upsell) {
          $matching_upsell.dispatchEvent(new Event('click', {bubbles: true}));
        }
      }
    },
    e_SelectUpsell(product, variant, plan_id) {
      let am = this;
      am.flags.add_upsell = !am.flags.add_upsell;
      am.selected_upsell.product = product;
      am.selected_upsell.variant = am.flags.add_upsell ? variant : null;
    },
    async e_AddToCart(e) {
      e.preventDefault();
      let $product_form = e.target.closest('.custom-product-atc-form');
      await UTILS.FormSubmitAjax($product_form);
      document.dispatchEvent(new CustomEvent('form:added-to-cart'));
      document.dispatchEvent(new Event('cart:modified'));
    }
  }));

  Alpine.data('ProductForm_v3', () => ({
    product_handle: '',
    flags: {
      variant_picker: false,
    },
    init() {
      let am = this;
      am.InitSelf();
      am.LoadProductForm();
      if (am.flags.variant_picker) {
        am.LoadVariantPicker();
      }
    },
    InitSelf() {
      let am = this;
      am.product_handle = am.$el.dataset.product;
      am.flags.variant_picker = am.$el.dataset.variant_picker == 'true';
      am.$el.classList.add('product-form-wrap');
    },
    async LoadProductForm() {
      let am = this;
      let section_id = 'product-form-v3';
      if (am.$el.querySelector('.custom-product-atc-form')) return;
      (async() => {
        let res = await fetch(`/products/${ am.product_handle }?sections=${ section_id }`).then((res => res.json()));
        let section_res = res[section_id];
        let $section = UTILS.ConvertStringToHTML(section_res);

        let $script = $section.querySelector('script#product-json');
        UTILS.ConvertStringToJS($script.textContent);

        let $product_form = $section.querySelector('.custom-product-atc-form');
        am.$el.insertAdjacentElement('beforeend', $product_form);
      })();
    },
    LoadVariantPicker() {
      let am = this;
      if (am.$el.querySelector('variant-radios')) return;

      (async() => {
        let product_res = await fetch(`/products/${ am.product_handle }`).then((res => res.text()))
        // console.log(product_res)
        let $section = UTILS.ConvertStringToHTML(product_res);
        if (!$section) return;

        let $variant_picker = $section.querySelector('variant-radios')
        if ($variant_picker) {
          $variant_picker.addEventListener('change', (e) => {
            // console.log(e);
            am.$el.dispatchEvent(new CustomEvent('variant-change', {detail: { e }}))
          });

          am.$el.insertAdjacentElement('afterbegin', $variant_picker);
        }
      })();
    }
  }));

  Alpine.data('CustomProductForm_V3', (product) => ({
    product: product,
    cache: {},
    quantity: 1,
    purchaseType: 'subscribe',
    current_selling_plan: null,
    current_variant: null,
    init() {
      let am = this;
      am.InitSelf();
      am.InitWatchers();
    },
    InitSelf() {
      let am = this;
      am.cache.$formWrap = am.$el.closest('.product-form-wrap');
      am.flags.variant_picker = am.cache.$formWrap.dataset.variant_picker == 'true';

      am.current_variant = am.GetCurrentVariant();
      am.current_selling_plan = am.GetSubscriptionPlan();
    },
    InitWatchers() {
      let am = this;
      am.$watch('quantity', () => {
        let current_variant = am.GetCurrentVariant();
        am.current_variant = current_variant;
        am.product.current_variant = current_variant;
        am.current_selling_plan = am.GetSubscriptionPlan();
      });
    },
    FormatMoney(cents) {
      return UTILS.FormatMoney(cents);
    },
    GetCurrentVariant() {
      let am = this;
      let variant = am.product.variants.find(v => v.title.includes(`${am.quantity} Pack`));
      return variant;
    },
    GetSubscriptionPlan() {
      let am = this;
      let variant = am.GetCurrentVariant();
      let selling_plans = am.product.selling_plan_groups[0].selling_plans.filter(item => item.name.includes(am.quantity)) || am.product.selling_plan_groups[0].selling_plans[0];
      let selling_plan = variant.selling_plan_allocations.find(item => selling_plans.map(p => p.id).includes(item.selling_plan_id)) || variant.selling_plan_allocations[0];
      return selling_plan;
    },
    async e_AddToCart(e) {
      e.preventDefault();
      let $product_form = e.target.closest('.custom-product-atc-form');
      await UTILS.FormSubmitAjax($product_form);

        // First click triggers test participation
        const straightToCheckout = await window.shoplift.isHypothesisActive('019b011c-0329-796d-a94d-cc6d3e401f2b');
  
        if (straightToCheckout) {
           window.location.href = '/checkout';
        } else {
      document.dispatchEvent(new CustomEvent('form:added-to-cart'));
      document.dispatchEvent(new Event('cart:modified'));
        }


    }
  }));
});